import BaseController from "../../controller/BaseController";
import { SearchField$LiveChangeEvent } from "sap/m/SearchField";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import ListBinding from "sap/ui/model/ListBinding";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class ProjectCalendarController extends BaseController {

    public async onInit(): Promise<void> {

    }

    onSearchFieldLiveChange(oEvent: SearchField$LiveChangeEvent): void {

        var oBinding = oEvent.getSource().getParent().getParent().getBinding("rows") as ListBinding;

        var aFilters = [];
        var sQuery = oEvent.getSource().getValue();
        if (sQuery && sQuery.length > 0) {
            aFilters.push(new Filter("user/firstName", FilterOperator.Contains, sQuery));
            aFilters.push(new Filter("user/lastName", FilterOperator.Contains, sQuery));
            const oCombinedFilter = new Filter({ filters: aFilters, and: false });
            oBinding.filter(oCombinedFilter, "Application");
        } else {
            oBinding.filter([]);
        }
    }

}
